import { useEffect, useState } from "react";
import styles from "./JobDescription.module.css";
import useNotification from "../../../hooks/useNotification";
import DashboardServices from "../../../services/DashboardServices";
import React from "react";
import { ENTERPRISE, ENTERPRISE_COMPANY } from "../../../urlConfig";
import CustomBreadcrumb from "../../CommonComponents/CustomBreadcrumb";
import { useLocation } from "react-router-dom";
import { Col, Row } from "antd";
import JobDetails from "./JobDetails";
import JobDetails2 from "./JobDetails2";
import JobServices from "../../../services/JobServices";

const JobDescription = () => {
  const { showNotification } = useNotification();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({});

  const location = useLocation();

  const BreadcrumbOptions = [
    {
      title: "Enterprise",
      link: ENTERPRISE,
    },
    {
      title: data?.company || "Company Name",
      link: ENTERPRISE_COMPANY + location?.pathname?.split("/")?.[3],
    },
    {
      title: data?.job_title || "Job post name",
      link:
        ENTERPRISE_COMPANY +
        location?.pathname?.split("/")?.[3] +
        "/job/" +
        location?.pathname?.split("/")?.[5],
    },
    {
      title: "Full job description",
    },
  ];

  useEffect(() => {
    const fetchUserOverviewData = async () => {
      try {
        const res = await JobServices.getJobById(location?.pathname?.split("/")?.[5]);
        setLoading(true);

        if (res) {
          if (res.statusCode === 1) {
            console.warn('data', res.data);
            
            setData(res.data);
          } else {
            handleError(`${res.statusDesc}`);
          }
        } else {
          handleError(`Error: ${res.statusDesc}`);
        }
      } catch (error) {
        console.log(error);
        if (error.statusCode === 0) {
          console.log("Error while fetching job info", error);
          handleError(error.description);
        } else {
          handleError("Error: Job info is not found.");
        }
      }
    };
    fetchUserOverviewData();
  }, []);

  const handleError = (error) => {
    setLoading(false);
    showNotification(error, "error");
  };

  return (
    <div className={styles.page_wrap}>
      <CustomBreadcrumb options={BreadcrumbOptions} />
      <Row gutter={[15, 35]} className={styles.column_wrap}>
        <Col xs={24} sm={24} md={24} lg={16} xl={16}>
          <JobDetails data={data} />
        </Col>
        <Col xs={24} sm={24} md={24} lg={8} xl={8}>
          <JobDetails2 data={data} />
        </Col>
      </Row>
    </div>
  );
};

export default JobDescription;
